import React, { useState, useEffect } from 'react';
import { Card, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import ReactApexChart from 'react-apexcharts';
import axios from '../../../utills/api';

const DealType = () => {
    const [chartData, setChartData] = useState([]);
    const [selectedPeriod, setSelectedPeriod] = useState('monthly');
    const [loading, setLoading] = useState(true);

    // API endpoints
    const apis = {
        Housekeeping: '/requests/guest',
        Food: '/food/order',
        Spa: '/spa',
        Wellness: '/wellness',
        Taxi: '/taxi-booking',
        Emergency: '/emergency-request',
        Complaints: '/complaints',
    };

const fetchData = async () => {
    setLoading(true);
    try {
        const housekeepingRes = await axios.get(apis.Housekeeping);
        const foodRes = await axios.get(apis.Food);
        const spaRes = await axios.get(apis.Spa);
        const wellnessRes = await axios.get(apis.Wellness);
        const taxiRes = await axios.get(apis.Taxi);
        const emergencyRes = await axios.get(apis.Emergency);
        const complaintRes = await axios.get(apis.Complaints);

        // Safe extraction using your pattern
        const housekeeping = Array.isArray(housekeepingRes.data) 
            ? housekeepingRes.data 
            : Array.isArray(housekeepingRes) 
                ? housekeepingRes 
                : [];

        const food = Array.isArray(foodRes.data) 
            ? foodRes.data 
            : Array.isArray(foodRes) 
                ? foodRes 
                : [];

        const spa = Array.isArray(spaRes.data) 
            ? spaRes.data 
            : Array.isArray(spaRes) 
                ? spaRes 
                : [];

        const wellness = Array.isArray(wellnessRes.data) 
            ? wellnessRes.data 
            : Array.isArray(wellnessRes) 
                ? wellnessRes 
                : [];

        const taxi = Array.isArray(taxiRes.data) 
            ? taxiRes.data 
            : Array.isArray(taxiRes) 
                ? taxiRes 
                : [];

        const emergency = Array.isArray(emergencyRes.data) 
            ? emergencyRes.data 
            : Array.isArray(emergencyRes) 
                ? emergencyRes 
                : [];

        const complaints = Array.isArray(complaintRes.data) 
            ? complaintRes.data 
            : Array.isArray(complaintRes) 
                ? complaintRes 
                : [];

        console.log('📊 Extracted Deal Type Data:', { housekeeping, food, spa, wellness, taxi, emergency, complaints });

      setChartData([
    housekeeping.length,
    food.length,
    spa.length,
    wellness.length,
    taxi.length,
    emergency.length,
    complaints.length
]);


    } catch (error) {
        console.error('❌ Error fetching deal type data:', error);
        setChartData([{ name: 'Requests', data: [0, 0, 0, 0, 0, 0, 0] }]);
    } finally {
        setLoading(false);
    }
};



    useEffect(() => {
        fetchData();
    }, [selectedPeriod]);

    const onChangeChartPeriod = period => {
        setSelectedPeriod(period);
        // Could pass period to API if needed
    };

    // Chart options
    const chartOptions = {
        chart: { type: 'donut', height: 341 },
        labels: Object.keys(apis),
        legend: { position: 'bottom', fontWeight: 500 },
        dataLabels: { enabled: true },
        responsive: [{
            breakpoint: 480,
            options: { chart: { height: 300 }, legend: { position: 'bottom' } }
        }],
        plotOptions: { pie: { donut: { size: '50%' } } },
        fill: { opacity: 0.9 },
        colors: ['#f6c23e', '#e74a3b', '#1cc88a', '#36b9cc', '#4e73df', '#858796', '#fd7e14'], // sample colors
    };

    return (
        <React.Fragment>
            <Col lg={3} md={6}>
                <Card className="card-height-100">
                    <div className="card-header align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">Deal Type</h4>
                        <div className="flex-shrink-0">
                            <UncontrolledDropdown className="card-header-dropdown">
                                <DropdownToggle tag="a" className="text-reset dropdown-btn" role="button">
                                    <span className="fw-bold text-uppercase fs-12">Sort by: </span>
                                    <span className="text-muted">
                                        {selectedPeriod.charAt(0).toUpperCase() + selectedPeriod.slice(1)}
                                        <i className="mdi mdi-chevron-down ms-1"></i>
                                    </span>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">
                                    {['today', 'weekly', 'monthly', 'yearly'].map(period => (
                                        <DropdownItem
                                            key={period}
                                            onClick={() => onChangeChartPeriod(period)}
                                            className={selectedPeriod === period ? 'active' : ''}
                                        >
                                            {period.charAt(0).toUpperCase() + period.slice(1)}
                                        </DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </div>
                    <div className="card-body pb-0">
                        {loading ? (
                            <p className="text-center text-muted">Loading chart...</p>
                        ) : (
                            <ReactApexChart
                                options={chartOptions}
                                series={chartData.length ? chartData : [0, 0, 0, 0, 0, 0, 0]}
                                type="donut"
                                height="341"
                            />
                        )}
                    </div>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default DealType;
